module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.34da9884.svg";